// Mock data for SETL concept website

export const heroImages = {
  carousel: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402943/DSC_8350_dmznve.jpg', // Outer terrace dusk
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402939/DSC_8317_hzguam.jpg'  // Outside view of cabin
    // DSC_7915 moved to Promise 5 section on homepage
  ],
  interior: 'https://images.unsplash.com/photo-1551927411-95e412943b58',
  forest: 'https://images.unsplash.com/photo-1508193638397-1c4234db14d8'
};

export const tinyHouseImages = {
  hero: 'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402938/DSC_7933_hl4uqd.jpg',
  livingRoom: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402944/DSC_8376_oxnets.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402938/DSC_7890_mfwgdj.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402940/DSC_8344_td8lph.jpg'
  ],
  kitchen: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402933/DSC_7811_gzcv9d.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402937/DSC_7845_tinkhc.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402928/DSC_7750_q06idy.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402929/DSC_7762_nbhays.jpg'
  ],
  bedroom: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402930/DSC_7784_nkzw8e.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402932/DSC_7793_w2pvoj.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402931/DSC_7790_p0kzvi.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402923/DSC_7650_c687ta.jpg'
  ],
  bathroom: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402924/DSC_7712_xkbxes.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402924/DSC_7698_olitwb.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402924/DSC_7685_we4v4k.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402925/DSC_7725_r7znvg.jpg'
  ],
  terrace: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402943/DSC_8350_dmznve.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402944/DSC_8359_q5phrt.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402944/DSC_8391_my4ftr.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402938/DSC_7890_mfwgdj.jpg'
  ]
};

export const natureImages = {
  hero: 'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402352/DSC_8097_cedccb.jpg',
  dorset: [
    'https://images.unsplash.com/photo-1658434061692-c763f2b6be8e',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402281/DSC_7960_lan0i8.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402367/DSC_8474_ueasyh.jpg'
  ],
  sea: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402343/DSC_8007_wei2jg.jpg',
    'https://images.unsplash.com/photo-1658434062586-8c7aebd9b534',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402279/DSC_8032_edq63b.jpg'
  ],
  nature: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402342/DSC_7977_vr2nzk.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402344/DSC_7946_iqm8uz.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402351/DSC_8069_gmyazx.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402354/DSC_8018_vtsuxp.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402358/DSC_8090_prn5oq.jpg'
  ],
  walks: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402277/DSC_7986_xnfvpp.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402276/DSC_7981_emb9at.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402280/DSC_8060_yk2xog.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402284/DSC_8233_mrwbv5.jpg'
  ],
  nightSky: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402944/DSC_8359_q5phrt.jpg'
  ],
  infiniteQuietness: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402281/DSC_8011_dhzuke.jpg'
  ]
};

export const hostImages = {
  food: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402346/hires-4788_gybyal.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402368/food_met_kookpot_ywsnor.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402357/DSC_8401_mcfek3.jpg'
  ],
  animals: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402346/hires-4204_2_urwrj5.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402342/hires-5147_w00saz.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402349/Shilvinghampton-56-Edit_rdf2hv.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402369/DSC_8423_au9aze.jpg'
  ],
  safety: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1772045112/safety_support_2_tcwmaz.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1772045112/Schermafbeelding_2025-11-11_om_15.48.25_q6nfns.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402341/foto_tractor_qeasse.jpg'
  ],
  garden: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1772045112/shutterstock_1490684762_br2udg.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1772045113/shutterstock_2673154853_zf6wyy.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1772045113/shutterstock_1522201592_jjzsja.jpg'
  ],
  sauna: [
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1772525198/Sauna_Country_Cabin_Dorset_e7qjmi.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402362/DSC_8243_kopie_gzusqu.jpg',
    'https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402363/DSC_8507_hfujdh.jpg'
  ]
};